import { useLayoutEffect, useRef } from "react"
import { usePageNumberContext } from "./page-number-context"

export default function PageNumber() {
  const { register, getPageInfo } = usePageNumberContext()
  const elementRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (!elementRef.current) return
    return register(elementRef.current)
  }, [register])

  const { pageNumber, totalPages } = getPageInfo(elementRef.current)

  return (
    <div
      ref={elementRef}
      data-nordpar-page-number="true"
      className="d-flex justify-content-center"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '9mm',
        fontSize: '12px',
        color: '#888',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      {pageNumber === null ? '' : `Page ${pageNumber} of ${totalPages}`}
    </div>
  )
}
